import React from 'react'
import PropTypes from 'prop-types'
import { i18n } from '@fs/zion-locale'
import { GenericHeading } from '../typography/Headings'
import Ellipsis from '../ellipsis'
import Row from '../row'
import { Overline, Subheading, Paragraph } from '../typography'

export default function TextBlock({ overline, primaryText, secondaryText, badgeCount }) {
  return (
    <GenericHeading size="H6" supplementary as="div">
      {overline && (
        <Overline as="div">
          <Ellipsis>{overline}</Ellipsis>
        </Overline>
      )}
      <Row gutters="xxs" guttersY="none" as="span" ChildWrapper="span">
        {primaryText}
        {badgeCount !== null && badgeCount !== undefined && (
          <Paragraph as="span" secondary noShrinkX size="xs">
            ({badgeCount.toLocaleString(i18n.language)})
          </Paragraph>
        )}
      </Row>
      <Subheading as="div">{secondaryText}</Subheading>
    </GenericHeading>
  )
}

TextBlock.propTypes = {
  /** Overline text. */
  overline: PropTypes.string,

  /** Primary line of text. */
  primaryText: PropTypes.node,

  /** Secondary line of text. */
  secondaryText: PropTypes.node,

  /* Displays a badge count next to the primary text. */
  badgeCount: PropTypes.number,
}
